import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import {LoadingProvider} from "./components/loading/LoadingProvider";
import {DeviceProvider} from "./components/device/DeviceProvider";
import {AuthProvider} from "./components/auth/AuthProvider.tsx";

createRoot(document.getElementById('root')!).render(
    <DeviceProvider>
        <LoadingProvider>
            <AuthProvider>
                <App />
            </AuthProvider>
        </LoadingProvider>
    </DeviceProvider>
)
